<template>
  <div class="code-container">
    <div
      v-show="!hasCode"
      class="coupon">
      <div
        v-if="hasCoupon"
        class="coupon-body">
        <div

          class="flex flex-sb align">
          <div  class="coupon-content">
            <span class="title">Coupon</span>
            <span class="coupon-title"> {{couponData.title}}</span>
          </div>
          <div>
            <div class="flex">
              <v-button
                plain
                class="flex-3"
                :disabled="!isUse"
                @click="handlerSelectCoupon">
                <font-awesome-icon
                  icon="exchange-alt"></font-awesome-icon>
              </v-button>
              <v-button
                plain
                class="flex-1"
                :disabled="!isUse"
                @click="handlerDelete(1)">
                <font-awesome-icon
                  icon="trash-alt"></font-awesome-icon>
              </v-button>

            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="code-select-button">
        <div
          class="flex-sb flex aglin-inline">
          <div>
            <span class="title">Coupon</span>
          </div>
          <div>
            <v-button
              plain
              :disabled="!isUse||isRenew"
              @click="handlerCoupon">Select</v-button>
          </div>
        <!--        <v-button-->
        <!--          plain-->
        <!--          :disabled="!isUse"-->
        <!--          icon="user-friends"-->
        <!--          class="margin-button"-->
        <!--          @click="handlerReferral">Referral Code</v-button>-->
        </div>
      </div>
    </div>
    <!--    <div-->
    <!--      v-show="!hasCoupon"-->
    <!--      class="referrer">-->
    <!--      <div-->
    <!--        v-if="hasCode"-->
    <!--        class="coupon-body">-->
    <!--        &lt;!&ndash;      <span class="title">{{codeNumber==1?'Coupon':'Referral Code'}}</span>&ndash;&gt;-->

    <!--        <div  class="coupon-content ">-->
    <!--          <div class="flex flex-sb">-->
    <!--            <div-->
    <!--              :class="{'flex':!isSmall}"-->
    <!--              class=" aglin-flex">-->
    <!--              <span class="title margin-left">Referrer</span>-->
    <!--            </div>-->
    <!--            <div v-if="!isRenew">-->
    <!--              <div class="flex">-->
    <!--                <v-button-->
    <!--                  plain-->
    <!--                  class="flex-1"-->
    <!--                  :disabled="!isUse || isGuest"-->
    <!--                  @click="handlerDelete(2)">-->
    <!--                  <font-awesome-icon-->
    <!--                    icon="trash-alt"></font-awesome-icon>-->
    <!--                </v-button>-->

    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div>-->
    <!--            <span class="code-title"> {{codeDate.code}}</span>-->
    <!--          </div>-->
    <!--          <div-->
    <!--            v-if="isUser"-->
    <!--            class="coupon-name">-->
    <!--            <span-->
    <!--              class="link"-->
    <!--              @click="handlerUser(customer_profile.id)">-->
    <!--              {{customer_name}}-->
    <!--            </span>-->
    <!--          </div>-->
    <!--          <div class="tags">-->
    <!--            <span-->
    <!--              v-if="customer_profile.is_tier_base"-->
    <!--              class="span-status blue">-->
    <!--              Professional-->
    <!--            </span>-->
    <!--            <span-->
    <!--              v-if="customer_profile.verify_language"-->
    <!--              class="span-status"-->
    <!--              :class="{-->
    <!--                'verified': customer_profile.verified == 20,-->
    <!--                'pending_verify ': customer_profile.verified == -1,-->
    <!--                'not_verify': customer_profile.verified == -2-->
    <!--              }">-->
    <!--              {{ customer_profile.verify_language }}-->
    <!--            </span>-->
    <!--            <span-->
    <!--              v-if="customer_profile.is_flagged"-->
    <!--              class="span-status flag">-->
    <!--              Flagged-->
    <!--            </span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div-->
    <!--        v-else-->
    <!--        class="code-select-button">-->
    <!--        <div-->
    <!--          class="form-item "-->
    <!--          :class="{'flex flex-sb-center':!isSmall}">-->
    <!--          <div>-->
    <!--            <span class="title">Referral Code</span>-->
    <!--          </div>-->
    <!--          <div>-->
    <!--            <v-input-->
    <!--              v-model="code"-->
    <!--              append="Apply"-->
    <!--              @handlerAppend="handlerAppend"/>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <attach-customer
      ref="attachCustomer"
      @handlerSelectCustomer="handlerSelectCoupon"></attach-customer>
    <coupon-dialog
      ref="coupon-dialog"
      :customerId="customerId"
      :orderId="orderId"
      :isQuote="isQuote"
      :product="product"
      :classId="classId"
      :customer="customer"
      @coupon="computedCoupon">
    </coupon-dialog>
  </div>
</template>
<script>
import {applyOrderCode, verifyPromoCode} from '@/api/order'
import {referApplyCode} from '@/api/refer'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import CouponDialog from '@/views/quoting/dialogs/coupon-dialog'
import {mapActions, mapState} from 'vuex'
import {getAccountDetail} from '@/api/account'

export default {
  name: 'codeSelect',
  components:{
    attachCustomer,
    CouponDialog,
  },
  props: {
    orderId: [String, Number],
    customerId: [String, Number],
    product: [String, Number],
    classId: [String, Number],
    notApply: {
      type: Boolean,
      default: false
    },
    isSpon: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: true
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isUser: {
      type: Boolean,
      default: false
    },
    codeType: {
      type: String,
      default: ''
    },
    applyCode: {
      type: String,
      default: ''
    },
    customer:{
      type: Object,
      default: ()=>({})
    },
    useCode:{
      type: Number,
      default: 1
    },
    isGuest:{
      type: Boolean,
      default: false
    },
    isRenew:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      code: '',
      isReferral:false,
      coupon:{},
      customer_profile: {}
    }
  },
  computed:{
    ...mapState('coupon', ['selectCode']),
    customer_name(){
      let {isrd_nm} = this.customer_profile||{}
      return isrd_nm
    },
    hasCoupon(){
      //1 coupon 2 referral
      let {coupon,code} =  this.selectCode||{}
      let {selectCode=''} =coupon||{}
      return selectCode==1
    },
    hasCode(){
      //1 coupon 2 referral
      let {coupon,code} =  this.selectCode||{}
      let {selectCode=''} =code||{}
      return selectCode==2
    },
    couponData(){
      let {coupon} =  this.selectCode||{}
      return coupon||{}
    },
    codeDate(){
      let {code} =  this.selectCode||{}
      return code||{}
    },
    customer_id(){
      return this.customerId
    },
    isUse(){
      return this.useCode==1
    }
  },
  watch: {
    applyCode: {
      immediate: true,
      handler(val) {
        this.code = val
      }
    },
    customerId:{
      immediate: true,
      deep:true,
      handler(val,old) {
        if(old)
          if(val!==old){
            this.setSelectCode (null)
            this.setCouponData (null)
            this.code = ''
            this.$emit('check-code')
          }
      }
    },
    isSpon:{
      immediate: true,
      handler(val) {
        if(val){
          // this.setSelectCode (null)
          // this.setCouponData (null)
          // this.code = ''
          // this.$emit('check-code')
        }
      }
    },
    'selectCode.code.referrer_user_id':{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountDetail()
        }
      }
    },
  },
  methods: {
    ...mapActions('coupon', ['setSelectCode', 'setCouponData']),
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    handlerCoupon() {
      if (!this.customerId) {
        this.$refs.attachCustomer.showAttachCustomer()
      } else {
        this.$refs['coupon-dialog'].changeDialog()
      }
    },
    handlerSelectCoupon() {
      this.$refs['coupon-dialog'].changeDialog()
    },
    handlerDelete(num) {
      let params = this.selectCode||{}
      this.setSelectCode(null)
      if(num==1)
      {
        params.coupon = {}
        this.setCouponData (null)
      }
      if(num==2)
        params.code = {}
      this.setSelectCode(params)

      this.isReferral = false
      this.code = ''
      this.$emit('check-code')
    },
    computedCoupon(data) {
      let { coupon_code} = data||{}
      let params = this.selectCode||{}
      this.setSelectCode(null)
      if (coupon_code) {
        this.coupon = data
        params.coupon = {selectCode: 1, ...data}
        // this.couponData = {selectCode: 1, ...data}
        this.setCouponData(data.coupon_code)
      }else{
        params.coupon = null
        this.couponData = null
        // this.setSelectCode(params)
        this.setCouponData(null)
      }
      this.setSelectCode(params)
      this.$emit('check-code')
    },
    handlerAppend() {
      this.network().verifyPromoCode()
    },
    handlerReferral() {
      this.isReferral = true
    },
    network() {
      return {
        verifyPromoCode: async () => {
          let params = JSON.parse(JSON.stringify(this.selectCode||{}))
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customerId,
              code: this.code
            })
            // this.setSelectCode (null)
            // this.setCouponData (null)
            const {referrer_user_id,is_self,is_campaign_code} = data
            params.is_campaign_code = is_campaign_code
            if (referrer_user_id) {
              params.code = {
                selectCode: 2,
                code: this.code,
                referrer_user_id
              }
              if(is_self==1){
                this.$ConfirmBox({
                  isNewConfirm:true,
                  width:370,
                  title:'Referral Code',
                  confirmBtn:'Customer is Policyholder',
                  cancelBtn:'Don’t Use',
                  message: 'This refer code belongs to the same user as the attached customer. ',
                  message2: 'It can only be used when the customer is the actual policyholder.'
                }).then(() => {
                  this.setSelectCode(params)
                  this.$emit('check-code', this.code)
                })
              }else {
                this.setSelectCode(params)
                this.$emit('check-code', this.code)
              }
              // if (this.notApply) {
              //   this.$emit('check-code', this.code)
              // } else {
              //   // if(this.codeType == 'refer') {
              //   //   // refer 單
              //   //   this.network().referApplyCode()
              //   // } else {
              //   //   // 正常單
              //   //   this.network().applyOrderCode()
              //   // }
              //   // 整合成一個了
              //   this.$emit('check-code', this.code)
              //   // this.network().applyOrderCode()
              // }
            }
            if(is_campaign_code==1){
              params.code = {
                selectCode: 2,
                code: this.code,
              }
              this.setSelectCode(params)
              this.$emit('check-code', this.code)
            }

          } else {
            if (this.notApply) {
              params.code = {
                selectCode: 2,
                code: this.code,
                referrer_user_id
              }
              this.setSelectCode(params)
              this.$emit('check-code', this.code)
            } else {
              // if(this.codeType == 'refer') {
              //   // refer 單
              //   this.network().referApplyCode()
              // } else {
              //   // 正常單
              //   this.network().applyOrderCode()
              // }
              // 整合成一個了
              this.$emit('check-code', this.code)
              // this.network().applyOrderCode()
            }
          }
        },
        applyOrderCode: async () => {
          // let params = {}
          // if (this.selectCode) {
          //   let {selectCode, coupon_code, code} = this.selectCode
          //   if (selectCode === 1)
          //     params.coupon = coupon_code
          //   else if (selectCode === 2) params.code = code
          // }
          let {coupon={},code={}} = this.selectCode||{}
          let params = {}
          let {coupon_code}  = coupon||{}
          params.coupon = coupon_code
          params.code =code&&code.code
          const {data} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            // code: this.code,
            // coupon:this.coupon.coupon_code||''
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$emit('apply', {
            ...data,
          })
          this.hasCode = true
          //   this.formData.amount = data.amount
        },
        referApplyCode: async () => {
          const {data} = await referApplyCode({
            order_id: this.orderId,
            code: this.code
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          // this.$emit('apply', data.amount)
          this.$emit('apply', {
            ...data,
            code: this.code
          })
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.codeDate.referrer_user_id
          })
          this.customer_profile = data.customer_profile
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .code-container{
    .title{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
    }
    .margin-bottom{
      margin-bottom: 20px;
    }
    .aglin-inline{
      //border-bottom: 1px solid #E1E4E8;
    }
    .code-select-button {
      padding: 20px 0 0 0;
      ::v-deep .el-button {
        width: 100%;
        border-radius: 4px;
        color: #24292E;
        font-family: Inter;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 16px;
      }
      .margin-button{
        margin-bottom: 0!important;
      }
      .el-button + .el-button {
        margin-left: 0;
      }
      .icon-left{
        color: #1d43a0;
        margin-right: 8px;
      }
      .hand{
        cursor:pointer
      }
    }
    .coupon-body{
      //margin-bottom: 20px;
      .flex{
        justify-items: center;
        align-items: center;
      }
      .flex-3{
        flex: 3;
        //margin-right: 8px;
      }
      .flex-1{
        flex: 1;
      }
      .align{
        align-items: center;
        border-bottom: 1px solid #E1E4E8;
      }
      .flex-algin{
        align-items: center;
      }
    .coupon-content{
      //background: #fff;
      padding: 20px 0;
      //padding: 16px;
      //margin: 0 16px 16px 0;
      border-radius: 4px;
      width: 100%;

      //height: 120px;
      //border:1px solid #D1D5DA;
      display: flex;
      flex-direction: column;
      .aglin-flex{
        align-items: center;
        .margin-left{
          margin-right: 10px;
        }
      }
      .title{
        color: #24292E;
        //font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        margin-right: 10px;
      }
      .coupon-title{
        color: #586069;
        font-size:16px!important;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .code-title{
        color: #6A737D;
        font-weight: 400;
        font-size: 14px;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        height: 20px;
        line-height: 20px;
      }
      .coupon-name{
        span{
          color: #0366D6;
          font-family: Inter;
          font-size: 14px;
          // margin-top: 8px;
          cursor:pointer;
          height: 20px;
          line-height: 20px;
          display: inline-block;
        }
      }
      .tags{
        height: 20px;
        .span-status{
          display: inline-block;
          margin-right: 4px;
          padding: 0px 8px;
          height: 20px;
          border-radius: 100px;
          font-size: 12px;
          line-height: 20px;
          font-weight: 600;
          &.blue{
            color:#0366D6;
            border: 1px solid #0366D6;
          }
          &.verified{
            color:#22863a;
            border: 1px solid #22863a;
          }
          &.pending_verify{
            color:#dbab09;
            border: 1px solid #dbab09;
          }
          &.not_verify{
            color:#d73a49;
            border: 1px solid #d73a49;
          }
          &.flag{
            color:#C24E00;
            border: 1px solid #F66A0A;
          }
        }
      }
      .coupon-mark{
        margin-top: 8px;
        overflow: hidden;
        span{
          text-overflow: ellipsis;
          word-break: break-word;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      span{
        color: #586069;
        font-size: 12px;
      }
    }
    }
  }
</style>
